import type { FavoritePageState, FavoritePageStore } from '../domain/types'
import { identity } from 'ramda'
import { useStore } from 'zustand'
import { favoritePageStore } from './store'

export function useFavoritesSelector<T, A extends unknown[] = []>(
  selector: (state: FavoritePageState, ...args: A) => T,
  ...args: A
): T {
  const store = useStore(favoritePageStore, identity<FavoritePageStore>)
  return selector(store, ...args)
}
